import { DocumentMeta } from '../meta';
import { Amortization } from './amortization';
import { AmortizationState, OrgState } from './state';
import { WaterfallData } from './action';
import { WaterfallEvent, WaterfallRightholder } from './waterfall';

export interface SimulationSource {
  id: string,
  order: number,
  grossReceipts: number,
  reference: boolean,
  referencePercent: number,
}

export interface Simulation {
  _meta?: DocumentMeta;
  id: string;
  waterfallId: string;
  name: string;
  fromScratch: boolean;
  ticketPrice: number;
  ticketSold: number,
  data: Partial<WaterfallData & { sources?: SimulationSource[], events?: WaterfallEvent[] }>;
  date: Date;
  versionId: string;
  sharedWith: string[]; // Non admin orgIds that can read this simulation
  breakevenSubjectType: 'rightholder' | 'entitlement' | 'pool';
  breakevenSubject: string;
  breakevenContract: string;
  breakevenTarget: number;
  amortizationId: string;
}

export interface SourceSimulationResult {
  name: string,
  id: string,
  revenue: number,
}

export interface RightholderSimulationResult extends WaterfallRightholder {
  state: OrgState;
  sources: SourceSimulationResult[];
}

export interface AmortizationSimulationResult extends Omit<Amortization, 'filmCost'> {
  state: AmortizationState;
  percent: number;
  current: string;
  filmCost: string;
  isAmortized: boolean;
  leftToRecoup?: string;
  turnover: {
    total: number;
    perSource: Record<string, number>;
  }
}

export function createSimulation(params: Partial<Simulation>): Simulation {
  return {
    id: '',
    name: '',
    waterfallId: '',
    fromScratch: false,
    ticketPrice: 0,
    ticketSold: 0,
    data: {},
    versionId: '',
    date: new Date(),
    sharedWith: [],
    breakevenSubjectType: 'rightholder',
    breakevenSubject: '',
    breakevenContract: '',
    breakevenTarget: 0,
    amortizationId: '',
    ...params
  };
}


